import { graphql, navigate } from 'gatsby'
import React from 'react'
import 'react-lazy-load-image-component/src/effects/blur.css'
import showdown from 'showdown'
import DivisorLine from '../components/DivisorLine'
import LandingSection1 from '../components/LandingSection1'
import LandingSection2 from '../components/LandingSection2'
import TemplateWrapper2 from '../components/Layout2'
import ProjectRoll from '../components/ProjectRoll'
import BlogSection from "../pages/blog"
import { getImage } from '../utils'
const converter = new showdown.Converter()

export const LandingTemplate = ({
  isPreview = false,
  section1,
  section2,
}) => {
  return (
    <>
      {/* section 1 */}
      <LandingSection1 section1={section1} />

      {/* section 2 */}
      <LandingSection2 section2={section2} />

      {
        !isPreview && (
          <ProjectRoll />
        )
      }

      <DivisorLine />
      
      {
        !isPreview && (
          <BlogSection />
        )
      }
    </>
  )
};

const Landing = ({
  location,
  data
}) => {

  console.log('data.markdownRemark.frontmatter; :>> ', data.markdownRemark.frontmatter);
  const {
    section1: _section1,
    section2,
  } = data.markdownRemark.frontmatter;

  const section1 = {
    ..._section1,
    items: _section1.items.map(item => ({
      ...item,
      image: {
        ...item.image,
        image: getImage(item.image)
      }
    }))
  }

  return (
    <TemplateWrapper2
      location={location}>
      <LandingTemplate
        section1={section1}
        section2={section2}
      />
    </TemplateWrapper2>
  )
}

export default Landing

export const pageQuery = graphql`
  query Landing {
    markdownRemark(frontmatter: { templateKey: { eq: "landing" } }) {
      frontmatter {
        section1 {
          title
          items {
            image {
              image {
                childImageSharp {
                    fluid {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
              }
              alt
            }
            name
            desc
          }
        }
        section2 {
          title
          desc
          btnTitle
          videoIframe
          items {
            name
            desc
          }
        }
      }
    }
  }
`